import { render, staticRenderFns } from "./TiendaListItem.vue?vue&type=template&id=1893173b&scoped=true&"
import script from "./TiendaListItem.vue?vue&type=script&lang=js&"
export * from "./TiendaListItem.vue?vue&type=script&lang=js&"
import style0 from "./TiendaListItem.vue?vue&type=style&index=0&id=1893173b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893173b",
  null
  
)

export default component.exports